import {
  type UnionAddress,
  toUnionAddress,
} from "@anaconda/core/blockchain/address"
import { createScope } from "bunshi"

export interface ScopeState {
  walletAddress: UnionAddress
}

export const ProfileScope = createScope<ScopeState>({
  walletAddress: toUnionAddress(
    "ETHEREUM:0x0000000000000000000000000000000000000000",
  ),
})
